import CryptoJS from 'crypto-js';
import axiosIns, { API_URL } from "../_config"

const SECRET_KEY = "X9f!@#7LwPq8$RtBz3Kq1UvN4TxQ2Zm";

export const decryptData = (encryptedText) => {
    try {
        if (!encryptedText) return null;

        const bytes = CryptoJS.AES.decrypt(encryptedText, SECRET_KEY);
        const decrypted = bytes.toString(CryptoJS.enc.Utf8);

        if (!decrypted) return null;

        return JSON.parse(decrypted);
    } catch (err) {
        console.error("Failed to decrypt or parse JSON:", err);
        return null;
    }
};

export const SentOtp = async (pmobileNo) => {

    try {
        const response = await axiosIns.post(`${API_URL.SentOtp}`, {
            mobileNo: pmobileNo
        });

        if (response.status === 200 && response.data.isSuccess === 200) {
            return response.data.data;
        } else {
            return null;
        }
    } catch (error) {
        return null;
    }
}
export const VerifyOTP = async (pmobileNo, potp) => {

    try {
        const response = await axiosIns.post(`${API_URL.VerifyOTP}`, {
            mobileNo: pmobileNo,
            otp: potp
        });

        if (response.status === 200) {
            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        return null;
    }
}

export const getUserData = () => {
    const encrypted = localStorage.getItem("data");
    if (!encrypted) return null;

    try {
        const bytes = CryptoJS.AES.decrypt(encrypted, SECRET_KEY);
        const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return decryptedData;   // returns original loginDetail object
    } catch (error) {
        return null;
    }
}

export const GetLoginDetailByUserName = async (pUserName) => {
    try {
        const response = await axiosIns.get(API_URL.GetLoginDetailByUserName + "?pUserName=" + pUserName);

        if (response.status === 200) {
            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        return null;
    }
}

export const GetMenuDetailByTypeId = async (pMenuTypeId, pRoleId) => {
    try {
        const response = await axiosIns.get(API_URL.GetMenuDetailByTypeId + "?pMenuTypeId=" + pMenuTypeId + "&pRoleId=" + pRoleId);

        if (response.status === 200) {
            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        return null;
    }
}


/*Blog API */
export const SaveBlogDetail = async (formdata) => {
    try {
        const response = await axiosIns.post(API_URL.SaveBlogDetail, formdata, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
        );

        if (response.status === 200) {
            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        return null;
    }
}
export const getBlogDetailAll = async () => {
    try {
        const response = await axiosIns.get(API_URL.GetBlogDetailAll);

        if (response.status === 200 && response.data.isSuccess === 1) {
            return response.data.data;
        } else {
            return null;
        }
    } catch (error) {
        return null;
    }
}
export const deleteBlogDetailById = async (id) => {
    try {
        const response = await axiosIns.get(API_URL.DeleteBlogDetailById + "?pBlogDetailId=" + id);

        if (response.status === 200) {
            return response.data;
        } else {
            // throw new Error("Failed to fetch product Category data.");
        }
    } catch (error) {
        // Handle errors, either from axios or from invalid responses
        // throw new Error(error.response?.data?.message || "Please try again later.");
    }
}
/*Blog API */

/*Image API */
export const SaveImageDetail = async (formdata) => {
    try {
        const response = await axiosIns.post(API_URL.SaveImageDetail, formdata, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
        );

        if (response.status === 200) {
            return response.data;
        } else {
            // throw new Error("Failed to fetch product Category data.");
        }
    } catch (error) {
        // Handle errors, either from axios or from invalid responses
        // throw new Error(error.response?.data?.message || "Please try again later.");
    }
}
export const GetImageDetail = async (imagetype) => {
    try {
        const response = await axiosIns.get(API_URL.GetImageDetail + "?pImageType=" + imagetype);

        if (response.status === 200 && response.data.isSuccess === 1) {

            return response.data.data;
        } else {
            // throw new Error("Failed to fetch product Category data.");
        }
    } catch (error) {
        // Handle errors, either from axios or from invalid responses
        // throw new Error(error.response?.data?.message || "Please try again later.");
    }
}
export const deleteImageDetailById = async (id) => {
    try {
        const response = await axiosIns.get(API_URL.DeleteImageDetailById + "?pImageDetailId=" + id);

        if (response.status === 200) {
            return response.data;
        } else {
            // throw new Error("Failed to fetch product Category data.");
        }
    } catch (error) {
        // Handle errors, either from axios or from invalid responses
        // throw new Error(error.response?.data?.message || "Please try again later.");
    }
}
/*Image API */

/*Project API */
export const SaveProduct = async (formdata) => {
    try {
        const response = await axiosIns.post(API_URL.SaveProduct, formdata, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
        );

        if (response.status === 200) {
            return response.data;
        } else {
            // throw new Error("Failed to fetch product Category data.");
        }
    } catch (error) {
        // Handle errors, either from axios or from invalid responses
        // throw new Error(error.response?.data?.message || "Please try again later.");
    }
}

export const GetProductAll = async () => {
    try {
        const response = await axiosIns.get(API_URL.GetProductAll);

        if (response.status === 200 && response.data.isSuccess === 1) {
            return response.data.data;
        } else {
            // throw new Error("Failed to fetch product Category data.");
        }
    } catch (error) {
        // Handle errors, either from axios or from invalid responses
        // throw new Error(error.response?.data?.message || "Please try again later.");
    }
}

export const SaveProjectDetail = async (formdata) => {
    try {
        const response = await axiosIns.post(API_URL.SaveProjectDetail, formdata, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
        );

        if (response.status === 200) {
            return response.data;
        } else {
            // throw new Error("Failed to fetch product Category data.");
        }
    } catch (error) {
        // Handle errors, either from axios or from invalid responses
        // throw new Error(error.response?.data?.message || "Please try again later.");
    }
}
export const GetProjectDetailAll = async () => {
    try {
        const response = await axiosIns.get(API_URL.GetProjectDetailAll);

        if (response.status === 200 && response.data.isSuccess === 1) {
            return response.data.data;
        } else {
            // throw new Error("Failed to fetch product Category data.");
        }
    } catch (error) {
        // Handle errors, either from axios or from invalid responses
        // throw new Error(error.response?.data?.message || "Please try again later.");
    }
}

export const SavePortfolioType = async (formdata) => {
    try {
        const response = await axiosIns.post(API_URL.SavePortfolioType, formdata
        );
        if (response.status === 200) {
            return response.data;
        } else {
            // throw new Error("Failed to fetch product Category data.");
        }
    } catch (error) {
        // Handle errors, either from axios or from invalid responses
        // throw new Error(error.response?.data?.message || "Please try again later.");
    }
}

export const GetPortfolioType = async () => {
    try {
        const response = await axiosIns.get(API_URL.GetPortfolioType);

        if (response.status === 200 && response.data.isSuccess === 1) {
            return response.data.data;
        } else {
            // throw new Error("Failed to fetch product Category data.");
        }
    } catch (error) {
        // Handle errors, either from axios or from invalid responses
        // throw new Error(error.response?.data?.message || "Please try again later.");
    }
}

export const DeletePortFolioTypeById = async (id) => {
    try {
        const response = await axiosIns.get(API_URL.DeletePortfolioTypeById + "?pPortfolioTypeId=" + id);
        if (response.status === 200) {
            return response.data;
        } else {
            // throw new Error("Failed to fetch product Category data.");
        }
    } catch (error) {
        // Handle errors, either from axios or from invalid responses
        // throw new Error(error.response?.data?.message || "Please try again later.");
    }
}

export const deleteProjectDetailById = async (id) => {
    try {
        const response = await axiosIns.get(API_URL.DeleteProjectDetailById + "?pProjectDetailId=" + id);

        if (response.status === 200) {
            return response.data;
        } else {
            // throw new Error("Failed to fetch product Category data.");
        }
    } catch (error) {
        // Handle errors, either from axios or from invalid responses
        // throw new Error(error.response?.data?.message || "Please try again later.");
    }
}

export const DeleteProductById = async (id) => {
    try {
        const response = await axiosIns.get(API_URL.DeleteProductById + "?pProductId=" + id);

        if (response.status === 200) {
            return response.data;
        } else {
            // throw new Error("Failed to fetch product Category data.");
        }
    } catch (error) {
        // Handle errors, either from axios or from invalid responses
        // throw new Error(error.response?.data?.message || "Please try again later.");
    }
}

export const IsHomeDisplayProjectDetailById = async (id) => {
    try {
        const response = await axiosIns.get(API_URL.IsHomeDisplayProductById + "?pProductId=" + id);

        if (response.status === 200) {
            return response.data;
        } else {
            // throw new Error("Failed to fetch product Category data.");
        }
    } catch (error) {
        // Handle errors, either from axios or from invalid responses
        // throw new Error(error.response?.data?.message || "Please try again later.");
    }
}


/*Project API */


/*Tech Parter API */
export const SaveTechPartner = async (formdata) => {
    try {
        const response = await axiosIns.post(API_URL.SaveTechPartner, formdata, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
        );
        if (response.status === 200) {
            return response.data;
        } else {
            // throw new Error("Failed to fetch product Category data.");
        }
    } catch (error) {
        // Handle errors, either from axios or from invalid responses
        // throw new Error(error.response?.data?.message || "Please try again later.");
    }
}
export const GetTechPartner = async () => {
    try {
        const response = await axiosIns.get(API_URL.GetTechPartner);
        if (response.status === 200) {
            return response.data.data;
        } else {
            // throw new Error("Failed to fetch product Category data.");
        }
    } catch (error) {
        // Handle errors, either from axios or from invalid responses
        // throw new Error(error.response?.data?.message || "Please try again later.");
    }
}

export const DeleteTechPartnerById = async (id) => {
    try {
        const response = await axiosIns.get(API_URL.DeleteTechPartnerById + "?pTechPartnerId=" + id);
        if (response.status === 200) {
            return response.data;
        } else {
            // throw new Error("Failed to fetch product Category data.");
        }
    } catch (error) {
        // Handle errors, either from axios or from invalid responses
        // throw new Error(error.response?.data?.message || "Please try again later.");
    }
}

export const IsHomeDisplayTechPartnerById = async (id) => {
    try {
        const response = await axiosIns.get(API_URL.IsHomeDisplayTechPartnerById + "?pTechPartnerId=" + id);

        if (response.status === 200) {
            return response.data;
        } else {
            // throw new Error("Failed to fetch product Category data.");
        }
    } catch (error) {
        // Handle errors, either from axios or from invalid responses
        // throw new Error(error.response?.data?.message || "Please try again later.");
    }
}


/*Tech Parter API */


/*Client API */
export const SaveClientDetail = async (formdata) => {
    try {
        const response = await axiosIns.post(API_URL.SaveClientDetail, formdata
        );
        if (response.status === 200) {
            return response.data;
        } else {
            // throw new Error("Failed to fetch product Category data.");
        }
    } catch (error) {
        // Handle errors, either from axios or from invalid responses
        // throw new Error(error.response?.data?.message || "Please try again later.");
    }
}
export const GetClientDetail = async () => {
    try {
        const response = await axiosIns.get(API_URL.GetClientDetail);
        if (response.status === 200) {
            return response.data.data;
        } else {
            // throw new Error("Failed to fetch product Category data.");
        }
    } catch (error) {
        // Handle errors, either from axios or from invalid responses
        // throw new Error(error.response?.data?.message || "Please try again later.");
    }
}

export const DeleteClientDetailById = async (id) => {
    try {
        const response = await axiosIns.get(API_URL.DeleteClientDetailById + "?pClientDetailId=" + id);
        if (response.status === 200) {
            return response.data;
        } else {
            // throw new Error("Failed to fetch product Category data.");
        }
    } catch (error) {
        // Handle errors, either from axios or from invalid responses
        // throw new Error(error.response?.data?.message || "Please try again later.");
    }
}
/*Client API */

/*Testimonial API */
export const SaveTestimonial = async (formdata) => {
    try {
        const response = await axiosIns.post(API_URL.SaveTestimonial, formdata
        );
        if (response.status === 200) {
            return response.data;
        } else {
            // throw new Error("Failed to fetch product Category data.");
        }
    } catch (error) {
        // Handle errors, either from axios or from invalid responses
        // throw new Error(error.response?.data?.message || "Please try again later.");
    }
}
export const GetTestimonial = async () => {
    try {
        const response = await axiosIns.get(API_URL.GetTestimonial);
        if (response.status === 200) {
            return response.data.data;
        } else {
            // throw new Error("Failed to fetch product Category data.");
        }
    } catch (error) {
        // Handle errors, either from axios or from invalid responses
        // throw new Error(error.response?.data?.message || "Please try again later.");
    }
}

export const DeleteTestimonialById = async (id) => {
    try {
        const response = await axiosIns.get(API_URL.DeleteTestimonialById + "?pTestimonialId=" + id);
        if (response.status === 200) {
            return response.data;
        } else {
            // throw new Error("Failed to fetch product Category data.");
        }
    } catch (error) {
        // Handle errors, either from axios or from invalid responses
        // throw new Error(error.response?.data?.message || "Please try again later.");
    }
}

export const ApprovalTestimonialById = async (id) => {
    try {
        const response = await axiosIns.get(API_URL.ApprovalTestimonialById + "?pTestimonialId=" + id);
        if (response.status === 200) {
            return response.data;
        } else {
            // throw new Error("Failed to fetch product Category data.");
        }
    } catch (error) {
        // Handle errors, either from axios or from invalid responses
        // throw new Error(error.response?.data?.message || "Please try again later.");
    }
}

/*Testimonial API */


/*Enquiry API */
export const GetEnquiry = async () => {
    try {
        const response = await axiosIns.get(API_URL.GetEnquiry);
        if (response.status === 200) {
            return response.data.data;
        } else {
            // throw new Error("Failed to fetch product Category data.");
        }
    } catch (error) {
        // Handle errors, either from axios or from invalid responses
        // throw new Error(error.response?.data?.message || "Please try again later.");
    }
}
/*Enquiry API */

/*Job Post Type*/

export const DeleteJobPostById = async (id) => {
    try {
        const response = await axiosIns.get(API_URL.DeleteJobPostById + "?pJobPostId=" + id);
        if (response.status === 200) {
            return response.data;
        } else {
            // throw new Error("Failed to fetch product Category data.");
        }
    } catch (error) {
        // Handle errors, either from axios or from invalid responses
        // throw new Error(error.response?.data?.message || "Please try again later.");
    }
}

export const GetJobPost = async () => {
    try {

        const response = await axiosIns.get(API_URL.GetJobPost);

        if (response.status === 200) {

            return response.data.data;
        } else {
            // throw new Error("Failed to fetch product Category data.");
        }
    } catch (error) {
        // Handle errors, either from axios or from invalid responses
        // throw new Error(error.response?.data?.message || "Please try again later.");
    }
}


export const SaveJobPost = async (formdata) => {
    try {
        const response = await axiosIns.post(API_URL.SaveJobPost, formdata
        );
        if (response.status === 200) {
            return response.data;
        } else {
            // throw new Error("Failed to fetch product Category data.");
        }
    } catch (error) {
        // Handle errors, either from axios or from invalid responses
        // throw new Error(error.response?.data?.message || "Please try again later.");
    }
}

export const ActiveJobPostById = async (id) => {
    try {
        const response = await axiosIns.get(API_URL.ActiveJobPostById + "?pJobPostId=" + id);
        if (response.status === 200) {
            return response.data;
        } else {
            // throw new Error("Failed to fetch product Category data.");
        }
    } catch (error) {
        // Handle errors, either from axios or from invalid responses
        // throw new Error(error.response?.data?.message || "Please try again later.");
    }
}
/*Job Post Type*/

/*Blog Type*/

export const DeleteBlogTypeById = async (id) => {
    try {
        const response = await axiosIns.get(API_URL.DeleteBlogTypeById + "?pBlogTypeId=" + id);
        if (response.status === 200) {
            return response.data;
        } else {
            // throw new Error("Failed to fetch product Category data.");
        }
    } catch (error) {
        // Handle errors, either from axios or from invalid responses
        // throw new Error(error.response?.data?.message || "Please try again later.");
    }
}

export const GetBlogType = async () => {
    try {

        const response = await axiosIns.get(API_URL.GetBlogType);

        if (response.status === 200) {

            return response.data.data;
        } else {
            // throw new Error("Failed to fetch product Category data.");
        }
    } catch (error) {
        // Handle errors, either from axios or from invalid responses
        // throw new Error(error.response?.data?.message || "Please try again later.");
    }
}


export const SaveBlogType = async (formdata) => {
    try {
        const response = await axiosIns.post(API_URL.SaveBlogType, formdata
        );
        if (response.status === 200) {
            return response.data;
        } else {
            // throw new Error("Failed to fetch product Category data.");
        }
    } catch (error) {
        // Handle errors, either from axios or from invalid responses
        // throw new Error(error.response?.data?.message || "Please try again later.");
    }
}
/*Job Post Type*/

// Work Type
export const SaveWorkType = async (formdata) => {
    try {
        const response = await axiosIns.post(API_URL.SaveWorkType, formdata
        );
        if (response.status === 200) {
            return response.data;
        } else {
            // throw new Error("Failed to fetch product Category data.");
        }
    } catch (error) {
        // Handle errors, either from axios or from invalid responses
        // throw new Error(error.response?.data?.message || "Please try again later.");
    }
}

export const GetWorkType = async () => {
    try {

        const response = await axiosIns.get(API_URL.GetWorkType);

        if (response.status === 200) {

            return response.data.data;
        } else {
            // throw new Error("Failed to fetch product Category data.");
        }
    } catch (error) {
        // Handle errors, either from axios or from invalid responses
        // throw new Error(error.response?.data?.message || "Please try again later.");
    }
}

export const DeleteWorkTypeById = async (id) => {
    try {
        const response = await axiosIns.get(API_URL.DeleteWorkTypeById + "?pWorkTypeId=" + id);
        if (response.status === 200) {
            return response.data;
        } else {
            // throw new Error("Failed to fetch product Category data.");
        }
    } catch (error) {
        // Handle errors, either from axios or from invalid responses
        // throw new Error(error.response?.data?.message || "Please try again later.");
    }
}


/*Job Enquiry*/
export const GetPostEnquiry = async () => {
    try {

        const response = await axiosIns.get(API_URL.GetPostEnquiry);

        if (response.status === 200) {

            return response.data.data;
        } else {
            // throw new Error("Failed to fetch product Category data.");
        }
    } catch (error) {
        // Handle errors, either from axios or from invalid responses
        // throw new Error(error.response?.data?.message || "Please try again later.");
    }
}
/*Job Enquiry*/

/*Quote Enquiry*/
export const GetQuotation = async () => {
    try {

        const response = await axiosIns.get(API_URL.GetQuotation);

        if (response.status === 200) {

            return response.data.data;
        } else {
            // throw new Error("Failed to fetch product Category data.");
        }
    } catch (error) {
        // Handle errors, either from axios or from invalid responses
        // throw new Error(error.response?.data?.message || "Please try again later.");
    }
}
/*Quote Enquiry*/
